import { TextField, Typography } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyledTableCell,
  useStyles,
} from "components/request-document/components/Commons";
import JobSection from "components/request-document/components/JobSection";
import WorkExperienceSection from "components/request-document/components/WorkExperienceSection";
import { useFormik } from "formik";
import {
  REQUEST_DOCUMENT_STEP,
  RoleId,
  STATUS_PROCESS,
} from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import {
  defaultJobTable,
  defaultWorkExperience,
  getDefaultRow,
  getErrorMessage,
  isError,
  mapJobTable,
  mapWorkExperience,
} from "libs/utils/form";
import { get } from "lodash-es";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartForm,
  addSmartFormSlice,
  getSmartForm,
  getSmartFormFieldConfig,
  selectAddSmartForm,
  selectCurrentSmartForm,
  selectCurrentSmartServiceId,
  selectDraftId,
  selectSmartFormFieldConfig,
} from "redux/modules/visaForm";
import * as yup from "yup";

export default function UserProfileStep2() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);

  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const draftId = useSelector(selectDraftId);
  const masterData = useSelector(selectMasterData);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const smartform = useSelector(selectCurrentSmartForm);

  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
  const smartformDetail = get(smartform, "detail", []).reduce(
    smartNameById,
    {}
  );

  const ConditionType = get(smartformDetail, "ConditionType.value", "");
  const isGovernment = !(
    ConditionType === "Start up" || ConditionType === "Company"
  );
  const personalId = get(personalDetail, "personalID", "");

  const detailList = [
    // "JobPosition",
    // "JobSubPosition",
    // "JobDescription",
    "JobTable",
    "ContractTermType",
    "ContractYear",
    "ContractMonth",
    "ContractPeriodFrom",
    "ContractPeriodTo",
    "ContractOther",
    "AverageIncomeBaht",
    "SalaryBaht",
    "OrtherIncome",
    "ContactPersonInThai",
    "ContactRelationship",
    "ContactEmail",
    "ContactMobile",
    "Investments",
    "WorkExperience",
    "Non",
    "Ven",
    "Tec",
    "Inc",
    "Oth",
  ];
  const detail = get(smartform, "detail", [])
    .filter((field) => detailList.includes(field.smartName))
    .reduce(smartNameById, {});

  useEffect(() => {
    dispatch(
      getMasterData({
        JobPositionConfig: true,
        CountryConfig: true,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());

        if (!isSaveDraft) {
          // if (isGovernment) {
          //   dispatch(setSmartFormStep(SMART_T_STEP.PART_C));
          // } else {
          //   dispatch(setSmartFormStep(SMART_T_STEP.PART_B));
          // }
          dispatch(setSmartFormStep(SMART_T_STEP.PART_B));
        } else {
          dispatch(
            getSmartForm({
              smartserviceId: smartServiceId,
              draftId,
              personalId,
            })
          );
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [
    addSmartFormState,
    dispatch,
    draftId,
    hideLoading,
    isGovernment,
    isSaveDraft,
    personalId,
    smartServiceId,
  ]);

  const callAPISubmit = async (values) => {
    showLoading();

    const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
    const documentFields = Object.keys(values);
    const getFieldListConfig = defaultType.filter((field) =>
      documentFields.includes(field.smartName)
    );

    const getValue = (field) => {
      switch (field.smartName) {
        case "WorkExperience": {
          const workExperience = get(values, field.smartName, []);
          const value = workExperience.filter((v) => !!v.WorkOrganization);
          return value || null;
        }
        case "JobTable": {
          const jobTable = get(values, field.smartName, []);
          const value = jobTable.filter((v) => !!v.jobTitle);
          return value || null;
        }
        default:
          return get(values, `${field.smartName}`, null);
      }
    };

    const getSmartId = (field) =>
      get(detail, `${field.smartName}.smartId`, null);

    const prepareData = {
      draftId: draftId || null,
      smartserviceId: smartServiceId,
      personalId: personalId,
      survey: null,
      visaissuance: null,
      detail: [
        ...getFieldListConfig.map((field) => ({
          smartName: field.smartName,
          smartId: getSmartId(field),
          partfromId: field.partfromId,
          configsmartId: field.configsmartId,
          linkTable: field.linkTable,
          value: getValue(field),
        })),
      ],
    };

    await dispatch(
      addSmartForm({
        data: prepareData,
      })
    );
  };

  const isDraftDocument = smartform?.statausID === STATUS_PROCESS.Draft;
  const validationSchema = yup.object({
    // ContactEmail: yup.string().email("Invalid email format"),
  });
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: isDraftDocument ? validationSchema : yup.object({}),
    initialValues: {
      // JobPosition: get(detail, "JobPosition.value", ""),
      // JobSubPosition: get(detail, "JobSubPosition.value", ""),
      // JobDescription: get(detail, "JobDescription.value", ""),
      JobTable: getDefaultRow(detail, "JobTable.value", defaultJobTable).map(
        mapJobTable
      ),
      ContactPersonInThai: get(detail, "ContactPersonInThai.value", ""),
      ContactRelationship: get(detail, "ContactRelationship.value", ""),
      ContactEmail: get(detail, "ContactEmail.value", ""),
      ContactMobile: get(detail, "ContactMobile.value", ""),
      Investments: get(detail, "Investments.value", ""),
      WorkExperience: getDefaultRow(
        detail,
        "WorkExperience.value",
        defaultWorkExperience
      ).map(mapWorkExperience),
      Non: get(detail, "Non.value", ""),
      Ven: get(detail, "Ven.value", ""),
      Tec: get(detail, "Tec.value", ""),
      Inc: get(detail, "Inc.value", ""),
      Oth: get(detail, "Oth.value", ""),
    },
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });
  const Role = useSelector((e) => {
    return e.user.profile.roleId;
  });
  // Disabled all field if status != draft
  if (!isDraftDocument && Role !== RoleId.Admin) {
    formik.handleBlur = () => {};
    formik.handleChange = () => {};
    formik.setFieldValue = () => {};
  }

  return (
    <div className={classes.root}>
      <form onSubmit={formik.handleSubmit}>
        <ContentTitle
          title="Application Form"
          subTitle="APPLICATION FOR QUALIFICATION ENDORSEMENT FOR SMART VISA “I”"
        />
        <Steper currentStep={1} stepInfo={REQUEST_DOCUMENT_STEP} />
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={6}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Part A : Personal Information
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* <TableRow>
                <StyledTableCell colSpan={6}>
                  <div className={classes.cellContent}>
                    <div className={classes.flexRow}>
                      <Bagde number={17} />
                      <InputLabel>Job position</InputLabel>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        fullWidth
                        style={{ marginLeft: 16, width: 300 }}
                      >
                        <InputLabel>Selected Job position</InputLabel>
                        <Select
                          label="Selected Job position"
                          name="JobPosition"
                          value={formik.values.JobPosition}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {jobPositionConfig.map((jobPosition) => (
                            <MenuItem
                              key={jobPosition.jobID}
                              value={jobPosition.jobID}
                            >
                              {jobPosition.jobName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        fullWidth
                        style={{ marginLeft: 16, width: 300 }}
                      >
                        <InputLabel>Selected Job Sub position</InputLabel>
                        <Select
                          label="Selected Job Sub position"
                          name="JobSubPosition"
                          value={formik.values.JobSubPosition}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {jobSubPositionConfig.map((jobPosition) => (
                            <MenuItem
                              key={jobPosition.jobsubID}
                              value={jobPosition.jobsubID}
                            >
                              {jobPosition.jobsubName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={6}>
                  <div className={classes.cellContent}>
                    <Bagde number={18} />
                    <div className={classes.wrapField}>
                      <InputLabel>Job description</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="JobDescription"
                        value={formik.values.JobDescription}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("JobDescription", formik)}
                        helperText={getErrorMessage("JobDescription", formik)}
                        multiline
                        rows={5}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow> */}

              {/* <TableRow>
                <StyledTableCell colSpan={6}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <Typography variant="h6" className={classes.title}>
                        Investments
                      </Typography>
                      <TextField
                        variant="outlined"
                        type="number"
                        className={classes.textField}
                        name="Investments"
                        value={formik.values.Investments}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("Investments", formik)}
                        helperText={getErrorMessage("Investments", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow> */}
              <JobSection formik={formik} />

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={22} />
                    <div className={classes.wrapField}>
                      <Typography variant="h6" className={classes.title}>
                        Name of contact person in Thailand
                      </Typography>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="ContactPersonInThai"
                        value={formik.values.ContactPersonInThai}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("ContactPersonInThai", formik)}
                        helperText={getErrorMessage(
                          "ContactPersonInThai",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Relationship with the applicant</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="ContactRelationship"
                        value={formik.values.ContactRelationship}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("ContactRelationship", formik)}
                        helperText={getErrorMessage(
                          "ContactRelationship",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>E-mail address</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="ContactEmail"
                        value={formik.values.ContactEmail}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("ContactEmail", formik)}
                        helperText={getErrorMessage("ContactEmail", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Phone number</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="ContactMobile"
                        // type="number"
                        inputProps={{ maxLength: 10 }}
                        onKeyDown={(e) => {
                          const pattern = /[^0-9]/g;
                          const isNotAllow =
                            e.key.length === 1 && pattern.test(e.key);

                          if (isNotAllow) {
                            e.preventDefault();
                          }
                        }}
                        value={formik.values.ContactMobile}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("ContactMobile", formik)}
                        helperText={getErrorMessage("ContactMobile", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              {/* <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>Non-startup technology company</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="Non"
                        type="number"
                        value={formik.values.Non}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("Non", formik)}
                        helperText={getErrorMessage("Non", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Venture Capital company</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="Ven"
                        type="number"
                        value={formik.values.Ven}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("Ven", formik)}
                        helperText={getErrorMessage("Ven", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>Technology startup company</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="Tec"
                        type="number"
                        value={formik.values.Tec}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("Tec", formik)}
                        helperText={getErrorMessage("Tec", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Incubation or accelerator program</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="Inc"
                        type="number"
                        value={formik.values.Inc}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("Inc", formik)}
                        helperText={getErrorMessage("Inc", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colSpan={6}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Other investment(s) (Please specify)
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="Oth"
                        type="number"
                        value={formik.values.Oth}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("Oth", formik)}
                        helperText={getErrorMessage("Oth", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow> */}

              <WorkExperienceSection
                defaultWorkExperience={mapWorkExperience(defaultWorkExperience)}
                formik={formik}
                bagde={23}
              />
              <div />
            </TableBody>
          </Table>
        </TableContainer>
        <div
          style={{
            marginTop: 44,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <InputLabel>
            Note: Income may include items beyond salary i.e. allowances,
            commissions which need to be appeared on the evidence of contract or
            the certification letter
          </InputLabel>
        </div>

        <ButtonController
          onClickSaveDraft={() => {
            setSaveDraft(true);
            callAPISubmit(formik.values);
          }}
        />
      </form>
    </div>
  );
}
